<template>
  <div class="banner">
    <img id="first" src="../../public/image/banner3.png" alt />
    <img id="second" src="../../public/image/banner32.png" style="display: none" alt />
    <div class="text" :class="{en_text:$i18n.locale=='en'}">
      <!-- <p class="title" :class="{fadeinup:fadeinup}">{{$t('home').about2.text0}}</p>
      <p class="subtitle" :class="{fadeinup2:fadeinup}">
        {{$t('home').about2.text1[0]}}
        <br />{{$t('home').about2.text1[1]}}
      </p> -->
      <!-- <p class="en" :class="{fadeinup3:fadeinup,en_none:$i18n.locale=='en'}">
        We will provide global users with more energy-saving, environmentally friendly, healthy, and comfortable
        <br />products, as well as more high-quality and efficient value-added services,There is no end to
        <br />satisfying the human pursuit of a higher quality of life!
      </p> -->
      <!-- <span class="btn" :class="{fadeinup4:fadeinup}">了解更多</span> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "banner",
  data() {
    return {
      fadeinup:false
    };
  },
  components: {},
  mounted() {},
  computed:{
    ...mapState(["shortMenu"]),
  },
  watch:{
    shortMenu(val) {
      if (val == "2"&&this.fadeinup!=true) {
        this.fadeinup=true
      }
    },
  },
  methods: {
    gotoAbout() {
      window.open("/about.html", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>

.banner {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    z-index: 1;
    cursor: pointer;
    transform: scale(1);
    transition: all 5s;
  }
  .text {
    position: absolute;
    top: 25%;
    left: 16%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    p {
      text-align: start;
      padding-left: 20px;
      border-left: 1px solid #d0d0d069;
    }
    .title {
      font-family: "SOURCEHANSANSCN-BOLD";
      font-size: 40px;
      color: white;
      line-height: 80px;
    }
    .fadeinup {
      animation: fadeInUp 2000ms;
    }
    .fadeinup2 {
      animation: fadeInUp2 2000ms;
    }
    .fadeinup3 {
      animation: fadeInUp3 2000ms;
    }
    .fadeinup4 {
      animation: fadeInUp4 2000ms;
    }
    .subtitle {
      font-size: 40px;
      color: white;
      line-height: 60px;
      font-family: 'SOURCEHANSANSCN-EXTRALIGHT';
      border-left: 1px solid white;
    }
    .en {
      padding: 10px 20px;
      font-family: "it";
      font-weight: lighter;
      color: white;
      font-size: 20px;
      line-height: 40px;
      text-shadow: 0 1px 3px #00000054;
    }
    .btn {
      padding: 10px 70px;
      color:white;
      background-color: rgba(255, 255, 255, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.5);
      // line-height: 25px;
      font-size: 16px;
      margin-top: 30px;
      margin-left: 20px;
      font-family: "SOURCEHANSANSCN-LIGHT";
      cursor: pointer;
      position: relative;
      transition: all 600ms;
      z-index: 2;
      &::after{
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        content: '';
        background-color: #ffffffa6;
        width: 0;
        height: 100%;
        transition: all 600ms;
        z-index: -1;
      }
      &:hover{
        color: #333333;
        &::after{
          width: 100%;
        }
      }
    }
  }
  .en_text{
    width: 80%;
  }
   @keyframes fadeInUp {
    from {
      transform: translateY(100px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes fadeInUp2 {
    from {
      transform: translateY(400px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes fadeInUp3 {
    from {
      transform: translateY(600px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes fadeInUp4 {
    from {
      transform: translateY(800px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
@media screen and (max-width:1000px) {
  .banner{
    .text{
      top: 20%;
      left: 0;
      .title{
        font-size: 20px;
        line-height: 30px;
      }
      .subtitle{
        font-size: 20px;
        line-height: 30px;
      }
      .en{
        font-size: 16px;
        line-height: 30px;
      }
      .en_none{
        display: none;
      }
    }
    .en_text{
      top: 10%;
      width: 100%;
    }
  }
}

@media screen and (max-width:768px) {
  .banner #first{
    display: none;
  }
  .banner #second{
    display: block !important;
  }
}


</style>
